/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="keyword" placeholder="输入用户手机号/昵称"></el-input>
        <!-- <el-input size="small" v-model="formInline.machineNo" placeholder="输入邀请人用户手机号"></el-input> -->
      </el-form-item>

      <!-- <el-form-item>
        <el-select size="small" v-model="formInline.statusType" placeholder="请选择">
          <el-option v-for="type in statusType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

            <el-select v-model="isVip" placeholder="请选择" @change="handleUserTypeChange" >

                <el-option label="普通用户" value="4"></el-option>
                <el-option label="待认证用户" value="3"></el-option>
                <el-option label="vip用户" value="1"></el-option>
                <el-option label="校长用户不限制公里" value="2"></el-option>
            </el-select>

            <el-form-item label="有效期：">
              <el-select v-if="isVip == '2'" v-model="principalValidityFilter" multiple clearable collapse-tags
                size="small" placeholder="全部状态（可多选）" style="width: 230px" @change="handleValidityFilterChange">
                <el-option label="未设置" value="unset" />
                <el-option label="有效" value="active" />
                <el-option label="失效" value="expired" />
                <el-option label="买断" value="buyout" />
              </el-select>
              <el-select
                v-if="isVip != '2'"
                v-model="validityFilter"
                size="small"
                placeholder="全部"
                @change="handleValidityFilterChange">
                <el-option label="全部" value=""></el-option>
                <el-option label="有效" value="active"></el-option>
                <el-option label="失效" value="expired"></el-option>
              </el-select>
            </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="expiry-toolbar">
      <template v-if="isVip=='2'">
        <div class="expiry-toolbar-title">
          <i class="el-icon-bell"></i>
          <span>到期提醒</span>
        </div>
        <el-button
          size="small"
          :type="expiryFilter === 'thisMonth' ? 'warning' : 'default'"
          icon="el-icon-date"
          @click="showThisMonthExpiry">
          本月到期 <strong>{{ expirySummary.thisMonthCount }}</strong> 个
        </el-button>
        <el-button
          v-if="expiryFilter"
          size="small"
          type="text"
          icon="el-icon-close"
          @click="clearExpiryFilter">
          显示全部
        </el-button>
      </template>
      <el-button
        class="batch-expire-button"
        size="small"
        type="primary"
        icon="el-icon-edit-outline"
        @click="openBatchExpireDialog">
        批量设置到期时间<span v-if="selectedUserRows.length">（{{ selectedUserRows.length }}）</span>
      </el-button>
    </div>
    <div
      v-show="tableHasHorizontalOverflow"
      ref="tableTopScrollbar"
      class="table-scrollbar-top"
      @scroll="handleTopTableScroll">
      <div class="table-scrollbar-top-content" :style="{ width: tableScrollWidth + 'px' }"></div>
    </div>
    <!--列表-->
    <el-table ref="userTable" class="user-table" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column label="选择" width="72" align="center">
        <template slot="header">
          <div class="user-selection-header">
            <el-checkbox
              :value="allUserRowsSelected"
              :indeterminate="userSelectionIndeterminate"
              :disabled="!listData.length"
              @change="toggleAllUserRows">
            </el-checkbox>
            <span>选择</span>
          </div>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            :value="isUserRowSelected(scope.row)"
            @change="toggleUserRow(scope.row, $event)">
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column sortable prop="id" label="id" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="avatar" label="头像" width="80"> 
        <template slot-scope="scope">
          <img class="tech-avatar" style="width: 40px; height: 40px;" :src="scope.row.avatar">
        </template>
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="campusName" label="校区名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="address" label="具体地址" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="realName" label="法人代表" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="identityCard" label="身份证号码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column v-if="isVip!='2'" sortable prop="inviterId" label="邀请人ID" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column v-if="isVip!='2'" prop="principalName" :label="isVip=='3' ? '所属校长（审核绑定）' : '所属校长'" :width="isVip=='3' ? 250 : 180">
        <template slot-scope="scope">
          <el-select
            v-if="isVip=='3'"
            v-model="pendingPrincipalSelections[String(scope.row.id)]"
            size="small"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="选择主校区/校长"
            :remote-method="loadPrincipalOptions"
            :loading="principalLoading"
            @focus="preparePendingPrincipalOptions(scope.row)"
            style="width: 100%;">
            <el-option
              v-for="item in principalOptions"
              :key="String(item.id)"
              :label="formatPrincipalOption(item)"
              :value="String(item.id)">
            </el-option>
          </el-select>
          <div v-else>{{ scope.row.principalName || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isVip=='3'" prop="principalCampusName" label="申请归属校区" width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.principalCampusName || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="phoneType" label="手机类型" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="remark" label="备注" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="用户类型" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.isVip==0">普通用户</div>
          <div v-if="scope.row.isVip==1">是vip用户</div>
          <div v-if="scope.row.isVip==2">校长用户</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="openingTime" label="VIP开通时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="VIP到期时间" width="210">
        <template slot-scope="scope">
          <div class="vip-expire-time">
            <span>{{ isEffectiveBuyout(scope.row) ? '永久有效' : (getEffectiveVipExpireTime(scope.row) || '-') }}</span>
            <el-tag v-if="isBoundVipChild(scope.row)" size="mini" type="info">跟随主账号</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="有效期状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="isEffectiveBuyout(scope.row) ? 'success' : getValidityStatusType(getEffectiveVipExpireTime(scope.row))">
            {{ isEffectiveBuyout(scope.row) ? '买断' : getValidityStatusText(getEffectiveVipExpireTime(scope.row)) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="isVip == '2'" label="更新费金额（元）" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openPrincipalValidity(scope.row)">{{ formatUpdateFee(scope.row.updateFeeAmount) }}</el-button>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{transformDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="340" fixed="right">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-button
              v-if="Number(scope.row.isVip) === 1 || Number(scope.row.isVip) === 2"
              size="mini" type="success" plain
              :loading="Boolean(copyingComicUsers[String(scope.row.id)])"
              :disabled="hasComicCertification(scope.row) || isExpired(getEffectiveVipExpireTime(scope.row))"
              :title="isExpired(getEffectiveVipExpireTime(scope.row)) ? '总系统认证已到期，请先更新有效期' : '复制校区、地址、定位及有效期，并自动开通漫画课程'"
              @click="copyComicCertification(scope.row)">
              {{ hasComicCertification(scope.row) ? '已有漫画认证' : '复制并开通漫画课程' }}
            </el-button>
            <el-button v-if="hasComicCertification(scope.row)" size="mini" type="text" @click="viewComicCertification(scope.row)">查看漫画认证</el-button>
            <el-button size="mini" type="primary" v-if="isVip=='3'" @click="setMemberStatus(2, scope.row.id,scope.row.remark,scope.row.openingTime,scope.row.vipExpireTime,scope.row.inviterId)">设为校长</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.isVip==0 && isVip=='3'" @click="approveVip(scope.row)">设为VIP</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.isVip==0 && isVip!='3'" @click="setMemberStatus(1, scope.row.id,scope.row.remark,scope.row.openingTime,scope.row.vipExpireTime,scope.row.inviterId)">设为VIP</el-button>
            <el-button size="mini" type="warning" v-if="scope.row.isVip==1||scope.row.isVip==2" @click="setMemberStatus(0, scope.row.id,scope.row.remark,scope.row.openingTime,scope.row.vipExpireTime,scope.row.inviterId)">取消VIP</el-button>
            <el-button size="mini" type="success" @click="open(scope.row.isVip, scope.row.id,scope.row.remark,scope.row.openingTime,scope.row.vipExpireTime,scope.row.inviterId)">备注</el-button>
            <el-button size="mini" type="success" @click="openOpeningDialog(scope.row)">设置VIP开通时间</el-button>
            <el-button size="mini" type="success" plain v-if="!isBoundVipChild(scope.row)" @click="openExpireDialog(scope.row)">{{ Number(scope.row.isVip) === 2 ? '设置有效期及更新费' : '设置VIP到期时间' }}</el-button>
            <el-button size="mini" type="primary" plain v-if="scope.row.isVip==1" @click="openBindDialog(scope.row)">绑定校长</el-button>
            <el-button size="mini" type="info" plain v-if="scope.row.isVip==2" @click="openPrincipalDetail(scope.row)">查看明细</el-button>
            <el-button size="mini" type="danger"  @click="setIsDelete(scope.row.id)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="设为VIP" :visible.sync="vipDialogVisible" width="460px" @close="closeVipDialog">
      <el-form label-width="110px">
        <el-form-item label="当前用户">
          <span>{{ vipForm.campusName || vipForm.realName || vipForm.mobile || vipForm.id }}</span>
        </el-form-item>
        <el-form-item v-if="vipForm.principalCampusName" label="申请归属校区">
          <span>{{ vipForm.principalCampusName }}</span>
        </el-form-item>
        <el-form-item label="账号类型">
          <el-radio-group v-model="vipForm.accountType" @change="handleVipAccountTypeChange">
            <el-radio label="standalone">独立VIP</el-radio>
            <el-radio label="child">子账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="vipForm.accountType === 'child'" label="选择主校区" required>
          <el-select
            v-model="vipForm.inviterId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入校区名/手机号搜索"
            :remote-method="loadPrincipalOptions"
            :loading="principalLoading"
            style="width: 100%;">
            <el-option
              v-for="item in principalOptions"
              :key="String(item.id)"
              :label="formatPrincipalOption(item)"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeVipDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="saveVipStatus">确认设为VIP</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置VIP开通时间" :visible.sync="openingFormVisible" width="420px" @close="closeOpeningDialog">
      <el-form label-width="110px">
        <el-form-item label="VIP开通时间">
          <el-date-picker
            v-model="openingForm.openingTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择VIP开通时间"
            clearable
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeOpeningDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="saveOpeningTime">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置校长有效期及更新费" :visible.sync="principalValidityVisible" width="520px"
      :close-on-click-modal="false" :show-close="!principalValiditySaving" :close-on-press-escape="!principalValiditySaving">
      <el-form label-width="120px">
        <el-form-item label="校长账号">{{ principalValidityForm.account }}</el-form-item>
        <el-form-item label="有效期类型">
          <el-radio-group v-model="principalValidityForm.validityMode" :disabled="principalValiditySaving">
            <el-radio label="unset">未设置</el-radio>
            <el-radio label="term">按到期时间</el-radio>
            <el-radio label="buyout">买断</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="principalValidityForm.validityMode === 'term'" label="VIP到期时间">
          <el-date-picker v-model="principalValidityForm.vipExpireTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择到期时间" :disabled="principalValiditySaving" style="width:100%" />
        </el-form-item>
        <el-form-item v-if="principalValidityForm.validityMode === 'buyout'">
          <span>买断后永久有效，绑定用户跟随主账号有效期。</span>
        </el-form-item>
        <el-form-item label="更新费金额">
          <el-input v-model="principalValidityForm.updateFeeAmount" placeholder="未填写" maxlength="11" :disabled="principalValiditySaving">
            <template slot="append">元</template>
          </el-input>
          <span style="color:#909399;font-size:12px">仅作记录，可留空，最多两位小数。</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" :disabled="principalValiditySaving" @click="principalValidityVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="principalValiditySaving" @click="savePrincipalValidity">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置VIP到期时间" :visible.sync="expireFormVisible" width="420px" @close="closeExpireDialog">
      <el-form label-width="110px">
        <el-form-item label="VIP到期时间">
          <el-date-picker
            v-model="expireForm.vipExpireTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择VIP到期时间"
            clearable
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeExpireDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="saveExpireTime">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量设置VIP到期时间" :visible.sync="batchExpireVisible" width="700px" custom-class="batch-expire-dialog" @close="closeBatchExpireDialog">
      <el-alert title="批量设置会将所选账号（绑定用户对应其主账号）改为按到期时间有效，包含买断账号；更新费金额保持不变。" type="info" :closable="false" style="margin-bottom:16px" />
      <el-form label-width="110px">
        <el-form-item label="已选用户">
          <el-button
            type="text"
            class="selected-users-toggle"
            :icon="selectedUsersExpanded ? 'el-icon-arrow-up' : 'el-icon-view'"
            @click="selectedUsersExpanded = !selectedUsersExpanded">
            共 {{ selectedUserRows.length }} 个账号，{{ selectedUsersExpanded ? '收起信息' : '查看基础信息' }}
          </el-button>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="selectedUsersExpanded" class="selected-users-table">
            <el-table :data="selectedUserRows" size="mini" border max-height="260">
              <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column label="姓名" width="110" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.realName || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号" width="140" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.mobile || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="校区名称" min-width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.campusName || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-transition>
        <el-form-item label="统一到期时间" required>
          <el-date-picker
            v-model="batchExpireForm.vipExpireTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择统一到期时间"
            :clearable="false"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBatchExpireDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="batchExpireLoading" @click="saveBatchExpireTime">确认批量设置</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定校长" :visible.sync="bindDialogVisible" width="420px" @close="closeBindDialog">
      <el-form label-width="90px">
        <el-form-item label="选择校长">
          <el-select
            v-model="bindForm.inviterId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入校区名/手机号搜索"
            :remote-method="loadPrincipalOptions"
            :loading="principalLoading"
            style="width: 100%;">
            <el-option
              v-for="item in principalOptions"
              :key="String(item.id)"
              :label="formatPrincipalOption(item)"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBindDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="savePrincipalBinding">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" width="860px" @close="closePrincipalDetail">
      <el-table size="small" :data="principalDetailList" border v-loading="principalDetailLoading" max-height="420">
        <el-table-column prop="id" label="ID" width="90"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="campusName" label="校区名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realName" label="法人代表" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="principalName" label="所属校长" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <span style="float:left;line-height:32px;">共 {{ principalDetailList.length }} 个VIP用户</span>
        <el-button size="small" @click="closePrincipalDetail">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click='closeDialog("edit")'>
      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="标题" prop="title">
          <el-input size="small" v-model="from.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
             



      </el-form>

      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="简短内容" prop="briefContent">
          <el-input size="small" v-model="from.briefContent" auto-complete="off" placeholder="简短内容"></el-input>
        </el-form-item>
             



      </el-form>


      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="分类名称" prop="roleName">
            <quill-editor
            v-model="from.content"
            :options="editorOption"
            style="height: 200px;"
            ref="QuillEditor">
            </quill-editor>
        </el-form-item>



      </el-form>






      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(0)">发送</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(1)">给所有人发送</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList,setUserInfo,setIsDelete,getPrincipalOptions,getPrincipalVipUsers,batchSetVipExpireTime,copyCertificationToComic,setPrincipalValidity} from '../../api/userMG'
import Pagination from '../../components/Pagination'





import client from "@/utils/ossClient.js";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];


export default {
  data() {
    return {
      uploadVisible:false,
      cursorIndex: 0,
      isVip:"3",
      copyingComicUsers: {},
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },


      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      openingFormVisible: false,
      expireFormVisible: false,
      batchExpireVisible: false,
      selectedUsersExpanded: false,
      vipDialogVisible: false,
      bindDialogVisible: false,
      detailDialogVisible: false,
      principalLoading: false,
      principalDetailLoading: false,
      batchExpireLoading: false,
      detailDialogTitle: '校长名下VIP明细',
      title: '预览',
      statusType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 1 },
        { key: '冻结', value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        pageSizes: [10, 20, 50, 100, 200],
        total: 10
        
      },

      keyword:"",
      validityFilter: "",
      principalValidityFilter: [],
      principalValidityVisible: false,
      principalValiditySaving: false,
      principalValidityForm: { id: '', account: '', validityMode: 'unset', vipExpireTime: '', updateFeeAmount: '' },
      expiryFilter: "",
      expirySummary: {
        thisMonthCount: 0
      },
      principalOptions: [],
      principalDetailList: [],
      pendingPrincipalSelections: {},
      selectedUserRows: [],
      tableScrollWidth: 0,
      tableViewportWidth: 0,
      tableBodyWrapper: null,
      tableResizeTimer: null,


      from:{
        title:"",
        briefContent:"",
        content:"",
        userId:"",
        sendType:0,

      },
      openingForm: {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      },
      expireForm: {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      },
      batchExpireForm: {
        vipExpireTime: ""
      },
      vipForm: {
        id: "",
        mobile: "",
        realName: "",
        campusName: "",
        principalCampusName: "",
        accountType: "standalone",
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      },
      bindForm: {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      }


    }
  },
  // 注册组件
  components: {
    Pagination
  },
  computed: {
    currentPageSelectedUserCount() {
      const selectedIds = new Set(this.selectedUserRows.map(item => String(item.id)))
      return this.listData.filter(item => selectedIds.has(String(item.id))).length
    },
    allUserRowsSelected() {
      return this.listData.length > 0 && this.currentPageSelectedUserCount === this.listData.length
    },
    userSelectionIndeterminate() {
      return this.currentPageSelectedUserCount > 0 && this.currentPageSelectedUserCount < this.listData.length
    },
    tableHasHorizontalOverflow() {
      return this.tableScrollWidth > this.tableViewportWidth + 1
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(1)
  },
  mounted() {
    window.addEventListener('resize', this.scheduleTableScrollbarRefresh)
    this.$nextTick(this.bindTableScrollbar)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleTableScrollbarRefresh)
    if (this.tableBodyWrapper) {
      this.tableBodyWrapper.removeEventListener('scroll', this.handleTableBodyScroll)
    }
    if (this.tableResizeTimer) {
      clearTimeout(this.tableResizeTimer)
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    hasComicCertification(row) {
      return Number(row.isVip2) > 0 || Boolean(String(row.openingTime2 || '').trim()) || Boolean(String(row.vip2ExpireTime || '').trim())
    },
    async copyComicCertification(row) {
      const userId = String(row.id)
      if (this.copyingComicUsers[userId] || this.hasComicCertification(row)) return
      this.$set(this.copyingComicUsers, userId, true)
      try {
        const res = await copyCertificationToComic({ id: row.id })
        if (res.code !== 200) {
          this.$message.error(res.msg || '复制开通失败，请重试')
          return
        }
        this.$set(row, 'isVip2', res.data.isVip2)
        this.$message.success(res.data.alreadyEnabled
          ? '该用户已有漫画认证，已保留原资料和有效期'
          : '认证资料已复制，漫画课程已自动开通，可点击“查看漫画认证”查看')
      } catch (error) {
        this.$message.error('请求失败，请刷新用户列表确认开通结果后再重试')
      } finally {
        this.$delete(this.copyingComicUsers, userId)
      }
    },
    viewComicCertification(row) {
      this.$router.push({
        path: '/User/User2',
        query: {
          mobile: row.mobile || row.realName || row.campusName2 || row.campusName || '',
          isVip2: String(row.isVip2)
        }
      })
    },
    isBoundVipChild(row) {
      if (!row || Number(row.isVip) !== 1) {
        return false
      }
      return row.inviterId !== null && row.inviterId !== undefined && String(row.inviterId).trim() !== ''
    },
    getEffectiveVipExpireTime(row) {
      if (!row) {
        return ''
      }
      return this.isBoundVipChild(row) ? (row.principalVipExpireTime || '') : (row.vipExpireTime || '')
    },
    isUserRowSelected(row) {
      const rowId = String(row && row.id)
      return this.selectedUserRows.some(item => String(item.id) === rowId)
    },
    toggleUserRow(row, checked) {
      const rowId = String(row && row.id)
      const selectedRows = this.selectedUserRows.filter(item => String(item.id) !== rowId)
      if (checked) {
        selectedRows.push(row)
      }
      this.selectedUserRows = selectedRows
    },
    toggleAllUserRows(checked) {
      const currentPageIds = new Set(this.listData.map(item => String(item.id)))
      const selectionsFromOtherPages = this.selectedUserRows.filter(
        item => !currentPageIds.has(String(item.id))
      )
      this.selectedUserRows = checked
        ? selectionsFromOtherPages.concat(this.listData)
        : selectionsFromOtherPages
    },
    bindTableScrollbar() {
      const table = this.$refs.userTable
      const bodyWrapper = table && table.bodyWrapper
      if (!bodyWrapper) {
        return
      }
      if (this.tableBodyWrapper && this.tableBodyWrapper !== bodyWrapper) {
        this.tableBodyWrapper.removeEventListener('scroll', this.handleTableBodyScroll)
      }
      if (this.tableBodyWrapper !== bodyWrapper) {
        this.tableBodyWrapper = bodyWrapper
        this.tableBodyWrapper.addEventListener('scroll', this.handleTableBodyScroll)
      }
      this.refreshTableScrollbar()
    },
    refreshTableScrollbar() {
      this.$nextTick(() => {
        const table = this.$refs.userTable
        if (table && table.doLayout) {
          table.doLayout()
        }
        this.$nextTick(() => {
          const bodyWrapper = table && table.bodyWrapper
          if (!bodyWrapper) {
            return
          }
          this.tableScrollWidth = bodyWrapper.scrollWidth
          this.tableViewportWidth = bodyWrapper.clientWidth
          const topScrollbar = this.$refs.tableTopScrollbar
          if (topScrollbar) {
            topScrollbar.scrollLeft = bodyWrapper.scrollLeft
          }
        })
      })
    },
    scheduleTableScrollbarRefresh() {
      if (this.tableResizeTimer) {
        clearTimeout(this.tableResizeTimer)
      }
      this.tableResizeTimer = setTimeout(() => {
        this.tableResizeTimer = null
        this.bindTableScrollbar()
      }, 80)
    },
    handleTopTableScroll(event) {
      if (this.tableBodyWrapper) {
        this.tableBodyWrapper.scrollLeft = event.target.scrollLeft
      }
    },
    handleTableBodyScroll(event) {
      const topScrollbar = this.$refs.tableTopScrollbar
      if (topScrollbar && Math.abs(topScrollbar.scrollLeft - event.target.scrollLeft) > 1) {
        topScrollbar.scrollLeft = event.target.scrollLeft
      }
    },
    preparePendingPrincipalOptions(row) {
      this.loadPrincipalOptions(row && row.principalCampusName ? row.principalCampusName : "")
    },
    approveVip(row) {
      const principalId = this.pendingPrincipalSelections[String(row.id)] || ""
      if (!principalId) {
        this.openVipDialog(row)
        return
      }
      this.setMemberStatus(
        1,
        row.id,
        row.remark,
        row.openingTime,
        row.vipExpireTime,
        principalId
      )
    },
    handleUserTypeChange() {
      this.validityFilter = ""
      this.principalValidityFilter = []
      this.expiryFilter = ""
      this.selectedUserRows = []
      this.pendingPrincipalSelections = {}
      this.getdata(1)
    },
    handleValidityFilterChange() {
      this.expiryFilter = ""
      this.getdata(1)
    },
    showThisMonthExpiry() {
      this.validityFilter = ""
      this.principalValidityFilter = []
      this.expiryFilter = "thisMonth"
      this.getdata(1)
    },
    clearExpiryFilter() {
      this.expiryFilter = ""
      this.getdata(1)
    },
    openVipDialog(row) {
      const inviterId = row.inviterId ? String(row.inviterId) : ""
      this.vipForm = {
        id: row.id,
        mobile: row.mobile || "",
        realName: row.realName || "",
        campusName: row.campusName || "",
        principalCampusName: row.principalCampusName || "",
        accountType: inviterId || row.principalCampusName ? "child" : "standalone",
        remark: row.remark || "",
        openingTime: row.openingTime || "",
        vipExpireTime: row.vipExpireTime || "",
        inviterId: inviterId
      }
      this.vipDialogVisible = true
      this.loadPrincipalOptions(row.principalCampusName || "")
    },
    closeVipDialog() {
      this.vipDialogVisible = false
      this.vipForm = {
        id: "",
        mobile: "",
        realName: "",
        campusName: "",
        principalCampusName: "",
        accountType: "standalone",
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      }
    },
    handleVipAccountTypeChange(accountType) {
      if (accountType === "standalone") {
        this.vipForm.inviterId = ""
        return
      }
      this.loadPrincipalOptions(this.vipForm.principalCampusName || "")
    },
    saveVipStatus() {
      if (this.vipForm.accountType === "child" && !this.vipForm.inviterId) {
        this.$message({
          type: "warning",
          message: "请选择子账号所属的主校区"
        })
        return
      }
      this.setMemberStatus(
        1,
        this.vipForm.id,
        this.vipForm.remark,
        this.vipForm.openingTime,
        this.vipForm.vipExpireTime,
        this.vipForm.accountType === "child" ? this.vipForm.inviterId : ""
      )
    },
    openOpeningDialog(row) {
      this.openingForm = {
        id: row.id,
        isVip: row.isVip,
        remark: row.remark || "",
        openingTime: row.openingTime || "",
        vipExpireTime: row.vipExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.openingFormVisible = true
    },
    closeOpeningDialog() {
      this.openingFormVisible = false
      this.openingForm = {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      }
    },
    saveOpeningTime() {
      this.setMemberStatus(
        this.openingForm.isVip,
        this.openingForm.id,
        this.openingForm.remark,
        this.openingForm.openingTime,
        this.openingForm.vipExpireTime,
        this.openingForm.inviterId
      )
    },
    isEffectiveBuyout(row) {
      return !!row && Number(this.isBoundVipChild(row) ? row.principalVipBuyout : row.vipBuyout) === 1
    },
    formatUpdateFee(value) {
      return value === null || value === undefined || value === '' ? '未填写' : Number(value).toFixed(2)
    },
    openPrincipalValidity(row) {
      this.principalValidityForm = {
        id: row.id,
        account: [row.campusName, row.realName, row.mobile].filter(Boolean).join(' / '),
        validityMode: Number(row.vipBuyout) === 1 ? 'buyout' : (row.vipExpireTime ? 'term' : 'unset'),
        vipExpireTime: row.vipExpireTime || '',
        updateFeeAmount: row.updateFeeAmount === null || row.updateFeeAmount === undefined ? '' : String(row.updateFeeAmount)
      }
      this.principalValidityVisible = true
    },
    async savePrincipalValidity() {
      if (this.principalValiditySaving) return
      const form = this.principalValidityForm
      const fee = form.updateFeeAmount.trim()
      if (fee && !/^[0-9]{1,8}(\.[0-9]{1,2})?$/.test(fee)) {
        this.$message.error('更新费金额须为0至99999999.99元，最多两位小数')
        return
      }
      if (form.validityMode === 'term' && !form.vipExpireTime) {
        this.$message.error('请选择到期时间')
        return
      }
      this.principalValiditySaving = true
      try {
        const res = await setPrincipalValidity({ id: form.id, validityMode: form.validityMode,
          vipExpireTime: form.validityMode === 'term' ? form.vipExpireTime : '', updateFeeAmount: fee || null })
        if (res.code !== 200) { this.$message.error(res.msg || '保存失败'); return }
        this.$message.success('有效期及更新费金额已保存')
        this.principalValidityVisible = false
        this.selectedUserRows = []
        this.getdata(this.pageparm.currentPage || 1)
      } catch (error) {
        this.$message.error('保存失败，请重试')
      } finally {
        this.principalValiditySaving = false
      }
    },
    openExpireDialog(row) {
      if (Number(row.isVip) === 2) { this.openPrincipalValidity(row); return }
      this.expireForm = {
        id: row.id,
        isVip: row.isVip,
        remark: row.remark || "",
        openingTime: row.openingTime || "",
        vipExpireTime: row.vipExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.expireFormVisible = true
    },
    closeExpireDialog() {
      this.expireFormVisible = false
      this.expireForm = {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      }
    },
    saveExpireTime() {
      this.setMemberStatus(
        this.expireForm.isVip,
        this.expireForm.id,
        this.expireForm.remark,
        this.expireForm.openingTime,
        this.expireForm.vipExpireTime,
        this.expireForm.inviterId
      )
    },
    openBatchExpireDialog() {
      if (!this.selectedUserRows.length) {
        this.$message({
          type: "warning",
          message: "请先勾选需要设置到期时间的账号"
        })
        return
      }
      this.batchExpireForm.vipExpireTime = ""
      this.selectedUsersExpanded = false
      this.batchExpireVisible = true
    },
    closeBatchExpireDialog() {
      this.batchExpireVisible = false
      this.selectedUsersExpanded = false
      this.batchExpireForm.vipExpireTime = ""
    },
    saveBatchExpireTime() {
      if (!this.batchExpireForm.vipExpireTime) {
        this.$message({
          type: "warning",
          message: "请选择统一到期时间"
        })
        return
      }
      const userIds = this.selectedUserRows.map(item => Number(item.id)).filter(id => id > 0)
      if (!userIds.length) {
        this.$message({
          type: "warning",
          message: "所选账号无效，请重新勾选"
        })
        return
      }
      this.batchExpireLoading = true
      batchSetVipExpireTime({
        userIds: userIds,
        vipExpireTime: this.batchExpireForm.vipExpireTime
      }).then((res) => {
        this.batchExpireLoading = false
        if (res.code == 200) {
          const updatedCount = res.data && res.data.updatedCount ? res.data.updatedCount : userIds.length
          this.$message({
            type: "success",
            message: `已统一设置 ${updatedCount} 个账号的到期时间`
          })
          this.selectedUserRows = []
          this.closeBatchExpireDialog()
          this.getdata(this.pageparm.currentPage || 1)
          return
        }
        this.$message({
          type: "info",
          message: res.msg,
        })
      }).catch(() => {
        this.batchExpireLoading = false
        this.$message({
          type: "error",
          message: "批量设置失败，请稍后重试"
        })
      })
    },
    openBindDialog(row) {
      this.bindForm = {
        id: row.id,
        isVip: row.isVip,
        remark: row.remark || "",
        openingTime: row.openingTime || "",
        vipExpireTime: row.vipExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.bindDialogVisible = true
      this.loadPrincipalOptions("")
    },
    closeBindDialog() {
      this.bindDialogVisible = false
      this.bindForm = {
        id: "",
        isVip: 0,
        remark: "",
        openingTime: "",
        vipExpireTime: "",
        inviterId: ""
      }
    },
    savePrincipalBinding() {
      this.setMemberStatus(
        this.bindForm.isVip,
        this.bindForm.id,
        this.bindForm.remark,
        this.bindForm.openingTime,
        this.bindForm.vipExpireTime,
        this.bindForm.inviterId
      )
    },
    loadPrincipalOptions(keyword) {
      this.principalLoading = true
      getPrincipalOptions({
        keyword: keyword || "",
        scene: 1
      }).then((res) => {
        this.principalLoading = false
        if (res.code == 200) {
          this.principalOptions = res.data.list || []
          return
        }
        this.$message({
          type: "info",
          message: res.msg,
        })
      }).catch(() => {
        this.principalLoading = false
      })
    },
    formatPrincipalOption(item) {
      return `${item.campusName || item.realName || '未命名校长'} / ${item.mobile || item.id}`
    },
    openPrincipalDetail(row) {
      this.detailDialogVisible = true
      this.detailDialogTitle = `${row.campusName || row.realName || '校长'} 名下VIP明细`
      this.principalDetailLoading = true
      this.principalDetailList = []
      getPrincipalVipUsers({
        principalId: row.id,
        scene: 1
      }).then((res) => {
        this.principalDetailLoading = false
        if (res.code == 200) {
          this.principalDetailList = res.data.list || []
          return
        }
        this.$message({
          type: "info",
          message: res.msg,
        })
      }).catch(() => {
        this.principalDetailLoading = false
      })
    },
    closePrincipalDetail() {
      this.detailDialogVisible = false
      this.detailDialogTitle = '校长名下VIP明细'
      this.principalDetailList = []
    },
    open(status,id,remark,openingTime,vipExpireTime,inviterId) {
      var self = this;
        this.$prompt('请输入备注', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          self.setMemberStatus(status,id,value,openingTime,vipExpireTime,inviterId)
          

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },

    
    setIsDelete(id) {
      this.loading = true;

      var parameter = {
        id: id
      };
      setIsDelete(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.getdata(1)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    setMemberStatus(status,id,remark,openingTime,vipExpireTime,inviterId) {
      this.loading = true;
      if (!openingTime) {
        openingTime = ""
      }
      if (!vipExpireTime) {
        vipExpireTime = ""
      }
      if (!inviterId) {
        inviterId = ""
      }
      var parameter = {
        isVip: status,
        remark:remark,
        openingTime:openingTime,
        vipExpireTime: vipExpireTime,
        inviterId: inviterId,
        id: id,
      };
      setUserInfo(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.closeOpeningDialog()
          this.closeExpireDialog()
          this.closeVipDialog()
          this.closeBindDialog()
          this.getdata(1)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    getValidityStatusText(expireTime) {
      if (!expireTime) {
        return '未设置'
      }
      if (this.isExpired(expireTime)) {
        return this.isDateInCurrentMonth(expireTime) ? '本月失效' : '失效'
      }
      return this.isDateInCurrentMonth(expireTime) ? '本月到期' : '有效'
    },
    getValidityStatusType(expireTime) {
      if (!expireTime) {
        return 'info'
      }
      if (!this.isExpired(expireTime) && this.isDateInCurrentMonth(expireTime)) {
        return 'warning'
      }
      return this.isExpired(expireTime) ? 'danger' : 'success'
    },
    isDateInCurrentMonth(expireTime) {
      const parsedTime = this.parseDateTime(expireTime)
      if (!parsedTime || Number.isNaN(parsedTime.getTime())) {
        return false
      }
      const now = new Date()
      return parsedTime.getFullYear() === now.getFullYear() && parsedTime.getMonth() === now.getMonth()
    },
    isExpired(expireTime) {
      const parsedTime = this.parseDateTime(expireTime)
      if (!parsedTime) {
        return false
      }
      return parsedTime.getTime() <= Date.now()
    },
    parseDateTime(value) {
      if (!value) {
        return null
      }
      const text = String(value).trim()
      if (!text) {
        return null
      }
      if (/^\d{4}[-/.]\d{1,2}[-/.]\d{1,2}$/.test(text)) {
        return new Date(text.replace(/[/.]/g, '-') + ' 23:59:59')
      }
      return new Date(text.replace(/\./g, '-').replace('T', ' '))
    },


    //自定义上传方法..
    mainImgUpload(file) {
      var self = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            self.getUrl(res.url);
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },
    getUrl(url) {
      this.uploadVisible = false;
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (url) {
        // 插入图片，res为服务器返回的图片链接地址

        quill.insertEmbed(this.cursorIndex, "image", url);
        // 调整光标到最后
        quill.setSelection(this.cursorIndex + 1);
      } else {
        // 提示上传失败信息
      }
    },



    // 获取数据方法
    getdata(page) {
      this.loading = true;
      var parameter = {
        mobile: this.keyword,
        page: (page - 1) * this.pageparm.pageSize,
        pageSize: this.pageparm.pageSize,
        isVip:this.isVip,
        expiryFilter: this.isVip == "2" ? (this.principalValidityFilter.join(',') || this.expiryFilter) : this.validityFilter
      };
      console.log("parameter",parameter)
      getUserList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pendingPrincipalSelections = {};
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          this.expirySummary = this.isVip == "2"
            ? (res.data.expirySummary || { thisMonthCount: 0 })
            : { thisMonthCount: 0 };
          this.$nextTick(this.bindTableScrollbar)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },


    // 分页插件事件
    callFather(parm) {
      console.log(parm)
      this.pageparm.pageSize = parm.pageSize
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getdata(1)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      this.from.userId = row.id;
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.expiry-toolbar {
  min-height: 54px;
  margin: 0 0 14px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  background: #fff9eb;
  border: 1px solid #f1d493;
  border-radius: 6px;
}
.expiry-toolbar-title {
  margin-right: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #7c4a12;
  font-weight: 600;
}
.expiry-toolbar-title i {
  color: #d97706;
  font-size: 17px;
}
.expiry-toolbar strong {
  margin: 0 2px;
  font-size: 16px;
}
.batch-expire-button {
  margin-left: auto;
}
.selected-users-toggle {
  padding: 0;
}
.selected-users-table {
  margin: -4px 0 20px;
}
.selected-users-table /deep/ .el-table__body-wrapper {
  overflow-y: auto;
}
.batch-expire-dialog {
  max-width: calc(100vw - 32px);
}
.table-scrollbar-top {
  width: 100%;
  height: 18px;
  margin: -6px 0 10px;
  overflow-x: auto;
  overflow-y: hidden;
  background: #eef2f7;
  border: 1px solid #d8e0ea;
  border-radius: 4px;
}
.table-scrollbar-top-content {
  height: 1px;
}
.table-scrollbar-top::-webkit-scrollbar {
  height: 12px;
}
.table-scrollbar-top::-webkit-scrollbar-track {
  background: #e8edf3;
  border-radius: 4px;
}
.table-scrollbar-top::-webkit-scrollbar-thumb {
  min-width: 80px;
  background: #8ea4bd;
  border: 2px solid #e8edf3;
  border-radius: 6px;
}
.table-scrollbar-top::-webkit-scrollbar-thumb:hover {
  background: #607f9f;
}
.user-selection-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  white-space: nowrap;
}
.user-table /deep/ .el-checkbox__inner {
  width: 17px;
  height: 17px;
  border: 2px solid #8da2b8;
}
.user-table /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.user-table /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #409eff;
}
.userRole {
  width: 100%;
}
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}
.vip-expire-time {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 20px;
}
</style>

 
 

 



// WEBPACK FOOTER //
// src/views/user/User.vue